module.exports = __webpack_public_path__ + "img/categorie-nos-prestations-famille-boutrais-big.a827cf1a.jpg";